import { useMemo } from 'react';
import { Typography } from '@mui/material';

import Number from 'src/components/common/Number';
import Image from 'src/components/Image';
import type { Validator } from 'src/types/validator';
import { fix, gt, times } from 'src/utils/number';

import {
  AmountContainer,
  Base02TextContainer,
  Container,
  ImageContainer,
  InfoBodyContainer,
  InfoTextContainer,
  RightChevronIconContainer,
  TitleContainer,
  ValidatorSelectButton,
  ValidatorSelectLeftContainer,
  ValidatorSelectRightContainer,
} from './styled';

import DefaultValidatorIcon from 'src/assets/svg/DefaultValidator.svg';
import { ReactComponent as RightChevronIcon } from 'src/assets/svg/RightChevron.svg';

type TxDetailsProps = {
  estimatedGasFee: string;
  onClickValidator?: () => void;
  currentValidator?: Validator;
  isOnlyEstimatedGasFee?: boolean;
};

export default function TxDetails({ estimatedGasFee, currentValidator, isOnlyEstimatedGasFee = false, onClickValidator }: TxDetailsProps) {
  const commission = useMemo(
    () => times(currentValidator?.commission.commission_rates.rate || '0', '100'),
    [currentValidator?.commission.commission_rates.rate],
  );

  const gasFee = useMemo(() => String(parseFloat(estimatedGasFee)), [estimatedGasFee]);
  return (
    <Container>
      <>
        <TitleContainer>
          <Typography variant="h3">Details</Typography>
        </TitleContainer>
        <InfoBodyContainer>
          {!isOnlyEstimatedGasFee && (
            <>
              <ValidatorSelectButton
                onClick={() => {
                  onClickValidator?.();
                }}
              >
                <ValidatorSelectLeftContainer>
                  <Typography variant="h7">Validator</Typography>
                  <RightChevronIconContainer>
                    <RightChevronIcon />
                  </RightChevronIconContainer>
                </ValidatorSelectLeftContainer>
                <ValidatorSelectRightContainer>
                  <ImageContainer>
                    <Image
                      src={`https://raw.githubusercontent.com/cosmostation/chainlist/main/chain/dydx/moniker/${currentValidator?.operator_address || ''}.png`}
                      defaultImgSrc={DefaultValidatorIcon}
                    />
                  </ImageContainer>
                  <Typography variant="h6">{currentValidator?.description.moniker}</Typography>
                </ValidatorSelectRightContainer>
              </ValidatorSelectButton>
              <InfoTextContainer>
                <Base02TextContainer>
                  <Typography variant="h7">Commisson</Typography>
                </Base02TextContainer>
                {gt(commission || '0', '0') ? <Typography variant="h4">{commission} %</Typography> : <Typography variant="h6">-</Typography>}
              </InfoTextContainer>
            </>
          )}

          <InfoTextContainer>
            <Base02TextContainer>
              <Typography variant="h7">Estimated Gas Fee</Typography>
            </Base02TextContainer>

            {gt(gasFee, '0') ? (
              <AmountContainer>
                <Typography variant="h4">~</Typography>
                &nbsp;
                <Number typoOfIntegers="h4" typoOfDecimals="h6">
                  {String(parseFloat(fix(gasFee, 6)))}
                </Number>
                &nbsp;
                <Typography variant="h6">DYDX</Typography>
              </AmountContainer>
            ) : (
              <Typography variant="h6">-</Typography>
            )}
          </InfoTextContainer>
        </InfoBodyContainer>
      </>
    </Container>
  );
}
